/** When your routing table is too long, you can split it into small modules **/

import Layout from '@/layout'

const realName = {
  path: '/real-name',
  component: Layout,
  redirect: '/real-name/personnel-list',
  name: 'RealName',
  meta: {
    title: 'realName',
    icon: 'renyuan1',
    perm: 'realNameManager'
  },
  children: [
    {
      path: 'personnel',
      component: () => import('@/layout/ComponentWrap.vue'),
      name: 'Personnel',
      meta: { title: 'personnel', perm: 'cSitePersonManager', icon: 'persons' },
      children: [
        {
          path: 'personnel-list',
          component: () =>
            import('@/views/personnel-list/components/personnel-list'),
          name: 'PersonnelList',
          meta: {
            title: 'personnelList',
            perm: 'cSitePersonManager',
            personType: 'WORKER'
          }
        },
        {
          path: 'manager-list',
          component: () =>
            import('@/views/personnel-list/components/personnel-list'),
          name: 'ManagerList',
          meta: {
            title: 'managerList',
            perm: 'cSitePersonManager',
            personType: 'MANAGER'
          }
        },
        {
          path: 'other-personnel-list',
          component: () =>
            import('@/views/personnel-list/components/personnel-list'),
          name: 'OtherPersonelList',
          meta: {
            title: 'otherPersonelList',
            perm: 'cSitePersonManager',
            personType: 'OTHER'
          }
        },
        {
          path: 'visite-person',
          component: () => import('@/views/real-name/visite-person/index.vue'),
          name: 'VisitePerson',
          meta: { title: 'visitePerson', perm: 'cSiteTemporaryInfo' }
        },
        {
          path: 'black-list',
          component: () => import('@/views/real-name/black-list/index.vue'),
          name: 'BlackList',
          meta: { title: 'blackList', perm: 'cSitePersonManager' }
        },
        {
          path: 'approve-staff',
          component: () => import('@/views/real-name/approve-staff/index.vue'),
          name: 'ApproveStaff',
          meta: { title: 'approveStaff', perm: 'cSiteTemporaryInfo' }
        },

        {
          path: 'cloud-attendance-person',
          component: () =>
            import('@/views/real-name/cloud-attendance-person/index.vue'),
          name: 'CloudAttendancePerson',
          meta: {
            title: 'cloudAttendancePerson',
            perm: 'cSiteVerifyPersonRecordManager'
          }
        }
      ]
    },
    {
      path: 'device',
      component: () => import('@/layout/ComponentWrap.vue'),
      name: 'Device',
      meta: {
        title: 'device',
        perm: 'cSiteVerifyDeviceManager',
        icon: 'faceDevice'
      },
      children: [
        {
          path: 'face-recognition',
          component: () => import('@/views/device/face-recognition/index.vue'),
          name: 'FaceRecognition',
          meta: { title: 'faceRecognition', perm: 'cSiteVerifyDeviceManager' }
        },
        {
          path: 'collector-device',
          component: () => import('@/views/device/face-recognition/index.vue'),
          name: 'CollectorDevice',
          meta: {
            title: 'collectorDevice',
            isCollector: true,
            perm: 'cSiteVerifyDeviceManager'
          }
        },
        {
          path: 'identify-record',
          component: () =>
            import('@/views/statistics/identify-record/index.vue'),
          name: 'IdentifyRecord',
          meta: {
            title: 'identifyRecord',
            perm: 'cSiteVerifyPersonRecordManager'
          }
        },
        {
          path: 'collector-record',
          component: () =>
            import('@/views/statistics/collector-record/index.vue'),
          name: 'CollectorRecord',
          meta: {
            title: 'collectorRecord',
            perm: 'cSiteVerifyPersonRecordManager'
          }
        }
      ]
    },
    {
      path: 'salary',
      component: () => import('@/layout/ComponentWrap.vue'),
      name: 'Salary',
      meta: { title: 'salary', perm: 'cSitePersonManager', icon: 'salary' },
      children: [
        {
          path: 'bank-card',
          component: () =>
            import('@/views/real-name/salary/back-card/index.vue'),
          name: 'BankCard',
          meta: { title: 'bankCard', perm: 'cSitePersonManager' }
        },
        {
          path: 'work-contract',
          component: () =>
            import('@/views/real-name/salary/work-contract/index.vue'),
          name: 'WorkContract',
          meta: { title: 'workContract', perm: 'cSitePersonManager' }
        },
        {
          path: 'pay-calculation',
          component: () =>
            import('@/views/real-name/salary/pay-calculation/page.vue'),
          name: 'PayCalculation',
          meta: { title: 'payCalculation', perm: 'cSalaryManager' }
        },
        {
          path: 'salary-statement',
          component: () =>
            import('@/views/statistics/salary-statement/index.vue'),
          name: 'SalaryStatement',
          meta: { title: 'salaryStatement', perm: 'cSalaryManager' }
        }
      ]
    },
    {
      path: 'statistics',
      component: () => import('@/layout/ComponentWrap.vue'),
      name: 'Statistics',
      meta: { title: 'statistics', perm: 'cStatistics', icon: 'statistics' },
      children: [
        {
          path: 'working-hours',
          component: () => import('@/views/statistics/working-hours/index.vue'),
          name: 'WorkingHours',
          meta: {
            title: 'workingHours',
            perm: 'cSiteVerifyPersonRecordManager'
          }
        },
        {
          path: 'attendance-report',
          component: () =>
            import('@/views/statistics/attendance-report/index.vue'),
          name: 'AttendanceReport',
          meta: { title: 'attendanceReport', perm: 'sitePersonAttendance' }
        },
        {
          path: 'enterprise-statistics',
          component: () =>
            import('@/views/real-name/enterprise-statistics/index.vue'),
          name: 'EnterpriseStatistics',
          meta: { title: 'enterpriseStatistics', perm: 'cPersonStatistics' }
        },
        {
          path: 'person-statistics',
          component: () =>
            import('@/views/real-name/person-statistics/index.vue'),
          name: 'PersonStatistics',
          meta: { title: 'personStatistics', perm: 'cPersonStatistics' }
        }
      ]
    }
  ]
}
export default realName
